import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import compose from '../../../hoc/compose';
import NumericInput from '../../numericInput/numericInput';
import displayNames from '../../displayNames';
var getRadius = function getRadius(_ref) {
  var position = _ref.position,
    value = _ref.value;
  var borderRadiusPosition = 'border' + _.startCase(position).replace(' ', '') + 'Radius';
  return _defineProperty({}, borderRadiusPosition, "".concat(value, "px"));
};
var Corner = function Corner(_ref3) {
  var getClassName = _ref3.getClassName,
    position = _ref3.position,
    onBlur = _ref3.onBlur,
    onChange = _ref3.onChange,
    onFocus = _ref3.onFocus,
    min = _ref3.min,
    max = _ref3.max,
    value = _ref3.value,
    unit = _ref3.unit;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-corner ' + position.replace('-', ' '))
  }, /*#__PURE__*/React.createElement(NumericInput, {
    unit: unit,
    className: "numeric-corner",
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    min: min,
    max: max,
    value: value,
    placeholder: "placeholder"
  }), /*#__PURE__*/React.createElement("div", {
    className: "corner-border",
    style: getRadius({
      position: position,
      value: value
    })
  }));
};
Corner.displayName = displayNames.CORNER;
Corner.propTypes = {
  max: PropTypes.number,
  min: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  position: PropTypes.oneOf(['top-right', 'top-left', 'bottom-right', 'bottom-left']),
  value: PropTypes.number.isRequired,
  unit: PropTypes.oneOfType([PropTypes.oneOf(['percent', 'px', 'angle', 'seconds', 'spx']), PropTypes.string])
};
Corner.defaultProps = {
  position: 'top-right'
};
export default compose(Corner);